var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M12.1446 12.2702C11.4996 11.1496 10.2884 10.3966 8.90509 10.3966H7.03729C5.65395 10.3966 4.4428 11.1496 3.79783 12.2702C4.82512 13.4143 6.31352 14.1322 7.97119 14.1322C9.62886 14.1322 11.1173 13.4113 12.1446 12.2702ZM0.5 8.52881C0.5 6.54733 1.28714 4.647 2.68826 3.24588C4.08938 1.84476 5.98971 1.05762 7.97119 1.05762C9.95267 1.05762 11.853 1.84476 13.2541 3.24588C14.6552 4.647 15.4424 6.54733 15.4424 8.52881C15.4424 10.5103 14.6552 12.4106 13.2541 13.8117C11.853 15.2129 9.95267 16 7.97119 16C5.98971 16 4.08938 15.2129 2.68826 13.8117C1.28714 12.4106 0.5 10.5103 0.5 8.52881ZM7.97119 8.99576C8.52848 8.99576 9.06295 8.77437 9.45702 8.38031C9.85108 7.98624 10.0725 7.45178 10.0725 6.89449C10.0725 6.33719 9.85108 5.80273 9.45702 5.40866C9.06295 5.0146 8.52848 4.79321 7.97119 4.79321C7.4139 4.79321 6.87943 5.0146 6.48537 5.40866C6.0913 5.80273 5.86992 6.33719 5.86992 6.89449C5.86992 7.45178 6.0913 7.98624 6.48537 8.38031C6.87943 8.77437 7.4139 8.99576 7.97119 8.99576Z",
          fill: "#010A11",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }